import { Link, createFileRoute } from "@tanstack/react-router";
import { useAdminTenants, type TenantOverview } from "../api/hooks";
import { Chip, Empty, ErrorBox, Loading, Page, Table } from "../components/ui";
import { fmtDate, relative } from "../lib/format";

export const Route = createFileRoute("/admin")({ component: Organisations });

/** MVP-G3: every tenant on the platform and how collection is going for each. */
function Organisations() {
  const tenants = useAdminTenants();
  return (
    <Page title="Organisations" sub="Every tenant on the platform: what is connected, what we hold, and when we last collected. Counts only — never a person.">
      {tenants.isPending ? (
        <Loading />
      ) : tenants.isError ? (
        <ErrorBox error={tenants.error} />
      ) : tenants.data.length === 0 ? (
        <Empty title="No organisations yet" body="Tenants appear here as they are onboarded." />
      ) : (
        <Table
          rows={tenants.data}
          keyOf={(t) => t.id}
          cols={[
            { h: "Organisation", cell: (t) => <><Link to="/admin/$tenantId" params={{ tenantId: t.id }} className="font-semibold link">{t.name}</Link><span className="sub">{t.slug} · since {fmtDate(t.created_at)}</span></> },
            { h: "People", cell: (t) => <Num v={t.people} />, w: "90px" },
            { h: "Connections", cell: (t) => <Num v={t.connections} />, w: "110px" },
            { h: "Last collected", cell: (t) => <span className="text-muted">{t.last_sync_at ? relative(t.last_sync_at) : "never"}</span>, w: "140px" },
            { h: "Runs, 24h", cell: (t) => <Num v={t.runs_24h} />, w: "100px" },
            { h: "Failures, 24h", cell: (t) => <Failures t={t} />, w: "120px" },
            { h: "", cell: (t) => <Link to="/admin/$tenantId" params={{ tenantId: t.id }} className="btn btn-light !py-1.5 !px-3 !text-[12px]">Collection log →</Link>, w: "150px" },
          ]}
        />
      )}
    </Page>
  );
}

function Num({ v }: { v: number }) {
  return <span className={v === 0 ? "text-muted" : "font-semibold"}>{v.toLocaleString()}</span>;
}

function Failures({ t }: { t: TenantOverview }) {
  if (t.failures_24h === 0) return <Chip tone="good">none</Chip>;
  return <Chip tone="high">{t.failures_24h}</Chip>;
}
